import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { connect } from '../../Store';
import { __, formatPrice } from '../../Utils';
import Icon from 'oxyrion-ui/lib/Icon';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(15)};
  width: 100%;
  margin: ${rem(10)};
`;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: ${rem(8)};
`;

const BonusWrapper = styled.div`
  background: #f1f1f1;
  box-shadow: 1px 2px 0.98px 0.02px rgba(0, 0, 0, 0.09);
  margin-bottom: ${rem(16)};
  margin-right: ${rem(16)};
  padding: ${rem(8)};
`;

const BonuseName = styled.div``;

const Vouchers = styled.div`
  font-size: 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Col = styled.div``;

const SpacedRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
  margin-right: ${rem(4)};
`;

const Plan = styled.div`
  font-size: ${rem(12)};
`;

const Success = styled.div`
  color: green;
`;

const SuccesInfo = styled.div`
  font-size: ${rem(10)};
`;

const InfoWrapper = styled.div`
  margin-top: ${rem(8)};
`;

const IconsWrapper = styled.div`s`;

class Bonuses extends React.Component {
  getPersonTranslate(count) {
    if (count === 1) {
      return __('osobu');
    }

    if (count < 5) {
      return __('osoby');
    }

    return __('osôb');
  }

  renderIcons(count) {
    const icons = [];

    for (let i = 1; i <= count; i++) {
      icons.push(<Icon name="person" size="l" />);
    }

    return <IconsWrapper>{icons}</IconsWrapper>;
  }

  renderInfoPart(value) {
    const { firm, actualTurnover } = this.props;

    if (actualTurnover > value) {
      const actualVouchers = Math.round(actualTurnover / value);
      return (
        <Col>
          <Success>{`${__('Získavate bonus')} ${
            actualVouchers > 1 ? `${actualVouchers}x` : ''
          }`}</Success>
          <SuccesInfo>
            {`${__(
              'Ďalší poukaz je možné získať pri dosiahnutí obratu',
            )} ${formatPrice({
              amount: (actualVouchers + 1) * value,
              currency: firm === 'SK' ? 'EUR' : 'CZK',
            })}`}{' '}
          </SuccesInfo>
        </Col>
      );
    }

    return (
      <Row>
        <Label>{__('Pre získanie ešte potrebujete: ')}</Label>
        <Plan>
          {formatPrice({
            amount: value - actualTurnover,
            currency: firm === 'SK' ? 'EUR' : 'CZK',
          })}
        </Plan>
      </Row>
    );
  }
  render() {
    const { bonuses, firm } = this.props;

    return (
      <Wrapper>
        <Title>{__('Aktuálne bonusy')}</Title>
        {bonuses.map(b => (
          <BonusWrapper>
            <SpacedRow>
              <BonuseName>{b.name}</BonuseName>
              <Row>
                <Label>{__('Obrat: ')}</Label>
                <Plan>
                  {formatPrice({
                    amount: b.value,
                    currency: firm === 'SK' ? 'EUR' : 'CZK',
                  })}
                </Plan>
              </Row>
            </SpacedRow>
            <Vouchers>{`${b.vouchers_count} x pre ${
              b.persons_count
            }  ${this.getPersonTranslate(b.persons_count)}`}</Vouchers>
            <SpacedRow>
              <InfoWrapper>{this.renderInfoPart(b.value)}</InfoWrapper>
              {this.renderIcons(b.persons_count)}
            </SpacedRow>
          </BonusWrapper>
        ))}
      </Wrapper>
    );
  }
}

Bonuses.propTypes = {
  bonuses: PropTypes.arrayOf(PropTypes.shape()),
  firm: PropTypes.string,
  actualTurnover: PropTypes.number,
};

Bonuses.defaultProps = {
  bonuses: [],
  firm: 'SK',
  actualTurnover: 0,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Bonuses);



// WEBPACK FOOTER //
// ./src/Components/Bonuses/index.jsx